import * as React from "react";
import { Image } from "../../../image/image.mjs";
const CarouselPreviewItem = (props) => {
  const BEM = () => {
    const classArray = ["carousel-preview__item"];
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("button", { type: "button", className: BEM(), onClick: props.onClick }, /* @__PURE__ */ React.createElement(Image, { ...props.image, className: "carousel-preview__image", style: props.imageStyle, imageRef: props.imageRef }));
};
export {
  CarouselPreviewItem
};
